import { LeaseColumns } from '@miq/catalog';

export default {
  [LeaseColumns.LeaseCompDetails_AlternateAddress]: {
    field: 'alternate_address.full_street_name',
  },
};
